"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _render = require("rc-util/lib/React/render");
var _reactTransitionGroup = require("../utils/react/react-transition-group");
var _configProvider = require("../config-provider/configProvider");
var _classnames2 = _interopRequireDefault(require("classnames"));
var _Notice = _interopRequireDefault(require("./Notice"));
var _excluded = ["getContainer"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var seed = 0;
var now = Date.now();
function getUUID(prefixCls) {
  seed += 1;
  return "".concat(prefixCls, "_").concat(now, "_").concat(seed);
}
var NotificationCenter = /*#__PURE__*/function (_Component) {
  function NotificationCenter(props) {
    var _this;
    (0, _classCallCheck2.default)(this, NotificationCenter);
    _this = _callSuper(this, NotificationCenter, [props]);
    (0, _defineProperty2.default)(_this, "rootElement", void 0);
    _this.state = {
      notices: []
    };
    _this.add = _this.add.bind(_this);
    _this.remove = _this.remove.bind(_this);
    _this.rootElement = null;
    return _this;
  }
  (0, _inherits2.default)(NotificationCenter, _Component);
  return (0, _createClass2.default)(NotificationCenter, [{
    key: "add",
    value: function add(notice) {
      var _this2 = this;
      var _this$props = this.props,
        maxCount = _this$props.maxCount,
        type = _this$props.type;
      // 如果notice没有key，则生成一个唯一的key
      notice.key = notice.key || getUUID(type);
      var currentKey = notice.key;
      var originCloseHandler = notice.onClose;
      notice.onClose = function () {
        originCloseHandler === null || originCloseHandler === void 0 || originCloseHandler();
        _this2.remove(notice.key);
      };
      this.setState(function (previousState) {
        var notices = previousState.notices;
        // 查找当前通知是否已存在
        var noticeIndex = notices.map(function (v) {
          return v.key;
        }).indexOf(currentKey);
        var updatedNotices = notices.concat();
        if (noticeIndex !== -1) {
          // 如果通知已存在，更新该通知
          var previousNotice = notices.filter(function (v) {
            return v.key === notice.key;
          })[0];
          notice = _objectSpread({}, _this2.exitedCal(notice, previousNotice));
          updatedNotices.splice(noticeIndex, 1, notice);
        } else {
          // 如果通知不存在
          if (maxCount && notices.length >= maxCount) {
            /*
             * XXX, use key of first item to update new added (let React to move exsiting
             * instead of remove and mount). Same key was used before for both a) external
             * manual control and b) internal react 'key' prop , which is not that good.
             */
            // 如果已达到最大显示数，移除最早的通知，并更新新通知的位置
            notice = _objectSpread(_objectSpread({}, _this2.exitedCal(notice, updatedNotices[0])), {}, {
              updateKey: updatedNotices[0].updateKey || updatedNotices[0].key
            });
            updatedNotices.shift();
          } else {
            // 如果未达到最大显示数，计算新通知的位置
            notice.style = _this2.cal(notice);
          }
          // 添加新通知到列表
          updatedNotices.push(notice);
        }
        // 更新状态，触发重新渲染
        return {
          notices: updatedNotices
        };
      });
    }
  }, {
    key: "remove",
    value: function remove(key) {
      var _this$props$placement = this.props.placement,
        placement = _this$props$placement === void 0 ? '' : _this$props$placement;
      // 判断通知是在顶部还是底部显示，默认为顶部
      var isTop = placement ? placement.includes('top') : true;
      this.setState(function (previousState) {
        // 复制当前所有通知，避免直接修改状态
        var lastNotices = (0, _toConsumableArray2.default)(previousState.notices);
        // 过滤掉需要移除的通知
        var notices = lastNotices.filter(function (element) {
          return element.key !== key;
        });
        // 找到需要移除的通知
        var notice = lastNotices.filter(function (element) {
          return element.key === key;
        })[0];
        if (notice) {
          var _notice$ref;
          // @ts-ignore 获取通知对应的DOM节点
          var node = notice.currentNode || ((_notice$ref = notice.ref) === null || _notice$ref === void 0 ? void 0 : _notice$ref.current);
          // 获取通知的高度
          var height = (node === null || node === void 0 ? void 0 : node.offsetHeight) || 0;
          // 获取通知当前的Y轴偏移量
          var offsetY = parseInt((node === null || node === void 0 ? void 0 : node.style[isTop ? 'top' : 'bottom']) || '0', 10);
          for (var i = 0; i < notices.length; i++) {
            var _element$style;
            var element = notices[i];
            // 获取当前遍历到的通知的Y轴偏移量
            var currentOffsetY = parseInt(((_element$style = element.style) === null || _element$style === void 0 ? void 0 : _element$style[isTop ? 'top' : 'bottom']) || '0', 10);
            // 如果当前通知的Y轴偏移量大于被移除通知的Y轴偏移量，则需要上移
            if (currentOffsetY > offsetY) {
              element.style = _objectSpread(_objectSpread({}, element.style), {}, {
                // 根据通知是在顶部还是底部，计算新的Y轴偏移量
                top: isTop ? "".concat(currentOffsetY - height - 16, "px") : 'unset',
                bottom: isTop ? 'unset' : "".concat(currentOffsetY - height - 16, "px")
              });
            }
          }
        }
        // 返回更新后的通知列表
        return {
          notices: notices
        };
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this$rootElement;
      this.rootElement && (0, _render.unmount)(this.rootElement);
      (_this$rootElement = this.rootElement) === null || _this$rootElement === void 0 || (_this$rootElement = _this$rootElement.parentNode) === null || _this$rootElement === void 0 || _this$rootElement.removeChild(this.rootElement);
    }
    /**
     * 计算通知的样式，包括位置和偏移量。
     * @param notice 通知的属性
     * @returns {CSSProperties} 返回通知的样式对象
     */
  }, {
    key: "cal",
    value: function cal(notice) {
      // 获取通知的位置属性，默认为空字符串
      var _this$props$placement2 = this.props.placement,
        placement = _this$props$placement2 === void 0 ? '' : _this$props$placement2;
      // 获取当前所有通知实例
      var instances = this.state.notices;
      // 判断通知是在顶部还是底部显示，默认为顶部
      var isTop = placement ? placement.includes('top') : true;
      // 判断通知是在右侧还是左侧显示，默认为右侧
      var isRight = placement ? placement.toLowerCase().includes('right') : true;
      // 获取最后一个通知实例
      var lastInstance = instances[instances.length - 1];
      // 初始化偏移量
      var offsetY = 0;
      // 初始化当前通知的Y轴偏移量
      var currentInstanceY = 16;
      if (lastInstance) {
        var _lastInstance$style, _lastInstance$style2, _lastInstance$current;
        // 如果存在上一个通知实例，计算当前通知的Y轴偏移量
        offsetY = parseInt(isTop ? ((_lastInstance$style = lastInstance.style) === null || _lastInstance$style === void 0 ? void 0 : _lastInstance$style.top) || '0' : ((_lastInstance$style2 = lastInstance.style) === null || _lastInstance$style2 === void 0 ? void 0 : _lastInstance$style2.bottom) || '0', 10);
        // 加上上一个通知的高度和间隔
        currentInstanceY = offsetY + (((_lastInstance$current = lastInstance.currentNode) === null || _lastInstance$current === void 0 ? void 0 : _lastInstance$current.offsetHeight) || 0) + 16;
      }
      // 初始化右侧和左侧的偏移量
      var right = 0;
      var left = 0;
      if (placement) {
        // 根据通知的位置设置右侧或左侧的偏移量
        right = isRight ? '16px' : 'unset'; // 如果在右侧，则设置右侧偏移量为16px，否则不设置
        left = isRight ? 'unset' : '16px'; // 如果在左侧，则设置左侧偏移量为16px，否则不设置
      }
      // 返回计算后的样式对象
      return _objectSpread(_objectSpread({}, notice.style), {}, {
        top: isTop ? "".concat(currentInstanceY, "px") : 'unset',
        // 如果在顶部，则设置top属性，否则不设置
        bottom: isTop ? 'unset' : "".concat(currentInstanceY, "px"),
        // 如果在底部，则设置bottom属性，否则不设置
        right: right,
        left: left
      });
    }
    /**
     * 更新通知属性，保留当前节点和引用，同时合并新旧通知的样式。
     * @param notice 新的通知属性
     * @param previousNotice 之前的通知属性
     * @returns {NoticeConfig} 合并后的通知属性
     */
  }, {
    key: "exitedCal",
    value: function exitedCal(notice, previousNotice) {
      var _notice$style$top, _notice$style, _previousNotice$style, _notice$style$bottom, _notice$style2, _previousNotice$style2, _notice$style$right, _notice$style3, _previousNotice$style3, _notice$style$left, _notice$style4, _previousNotice$style4;
      return _objectSpread(_objectSpread({}, notice), {}, {
        // 保留当前节点和引用，以便在更新时可以直接操作DOM
        currentNode: previousNotice.currentNode,
        ref: previousNotice.ref,
        // 合并新旧通知的样式，优先使用新通知的样式，如果新通知中没有定义，则使用旧通知的样式
        style: _objectSpread(_objectSpread({}, notice.style), {}, {
          top: (_notice$style$top = (_notice$style = notice.style) === null || _notice$style === void 0 ? void 0 : _notice$style.top) !== null && _notice$style$top !== void 0 ? _notice$style$top : (_previousNotice$style = previousNotice.style) === null || _previousNotice$style === void 0 ? void 0 : _previousNotice$style.top,
          bottom: (_notice$style$bottom = (_notice$style2 = notice.style) === null || _notice$style2 === void 0 ? void 0 : _notice$style2.bottom) !== null && _notice$style$bottom !== void 0 ? _notice$style$bottom : (_previousNotice$style2 = previousNotice.style) === null || _previousNotice$style2 === void 0 ? void 0 : _previousNotice$style2.bottom,
          right: (_notice$style$right = (_notice$style3 = notice.style) === null || _notice$style3 === void 0 ? void 0 : _notice$style3.right) !== null && _notice$style$right !== void 0 ? _notice$style$right : (_previousNotice$style3 = previousNotice.style) === null || _previousNotice$style3 === void 0 ? void 0 : _previousNotice$style3.right,
          left: (_notice$style$left = (_notice$style4 = notice.style) === null || _notice$style4 === void 0 ? void 0 : _notice$style4.left) !== null && _notice$style$left !== void 0 ? _notice$style$left : (_previousNotice$style4 = previousNotice.style) === null || _previousNotice$style4 === void 0 ? void 0 : _previousNotice$style4.left
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        style = _this$props2.style,
        placement = _this$props2.placement,
        type = _this$props2.type;
      var notices = this.state.notices;
      return /*#__PURE__*/_react.default.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
        var getPrefixCls = _ref.getPrefixCls;
        var prefixCls = getPrefixCls(type);
        var cls = (0, _classnames2.default)("".concat(prefixCls), (0, _defineProperty2.default)({}, "".concat(prefixCls, "-").concat(placement), placement));
        return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.TransitionGroup, {
          className: cls,
          style: style
        }, notices.map(function (notice, index) {
          var update = Boolean(index === notices.length - 1 && notice.updateKey);
          var key = notice.updateKey ? notice.updateKey : notice.key;
          return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
            key: key,
            timeout: 300,
            classNames: "".concat(prefixCls, "-notice-item"),
            onEnter: function onEnter(node) {
              notice.currentNode = node;
            }
          }, /*#__PURE__*/_react.default.createElement(_Notice.default, {
            className: notice.className,
            style: notice.style,
            prefixCls: prefixCls,
            update: update,
            onClose: notice.onClose,
            duration: notice.duration
          }, notice.content));
        }));
      });
    }
  }], [{
    key: "newInstance",
    value: function newInstance(properties, callback) {
      var getContainer = properties.getContainer,
        props = (0, _objectWithoutProperties2.default)(properties, _excluded);
      var div = document.createElement('div');
      if (getContainer) {
        var root = getContainer();
        root.appendChild(div);
      } else {
        document.body.appendChild(div);
      }
      var called = false;
      function ref(notification) {
        if (called) {
          return;
        }
        called = true;
        notification.rootElement = div;
        callback(notification);
      }
      (0, _render.render)( /*#__PURE__*/_react.default.createElement(NotificationCenter, _objectSpread(_objectSpread({}, props), {}, {
        ref: ref
      })), div);
    }
  }]);
}(_react.Component);
(0, _defineProperty2.default)(NotificationCenter, "contextType", _configProvider.ConfigContext);
(0, _defineProperty2.default)(NotificationCenter, "instance", null);
(0, _defineProperty2.default)(NotificationCenter, "displayName", 'NotificationCenter');
var _default = exports.default = NotificationCenter;